"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = setting;

var _constants = require("redux/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {};

function setting() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _constants.SettingConstants.SET_SETTING:
        case _constants.SettingConstants.LOAD_SETTINGS_SUCCESS:
            return (0, _extends3.default)({}, action.result);
        default:
            return state;
    }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/setting.js
// module id = 1913
// module chunks = 0